/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventdetectorEventEvent } from './EventdetectorEventEvent';
import {
    EventdetectorEventEventFromJSON,
    EventdetectorEventEventFromJSONTyped,
    EventdetectorEventEventToJSON,
} from './EventdetectorEventEvent';
import type { EventdetectorEventEventdetector } from './EventdetectorEventEventdetector';
import {
    EventdetectorEventEventdetectorFromJSON,
    EventdetectorEventEventdetectorFromJSONTyped,
    EventdetectorEventEventdetectorToJSON,
} from './EventdetectorEventEventdetector';
import type { GeoJson } from './GeoJson';
import {
    GeoJsonFromJSON,
    GeoJsonFromJSONTyped,
    GeoJsonToJSON,
} from './GeoJson';
import type { ShipType } from './ShipType';
import {
    ShipTypeFromJSON,
    ShipTypeFromJSONTyped,
    ShipTypeToJSON,
} from './ShipType';

/**
 * 
 * @export
 * @interface EventdetectorEvent
 */
export interface EventdetectorEvent {
    /**
     * 
     * @type {EventdetectorEventEvent}
     * @memberof EventdetectorEvent
     */
    event?: EventdetectorEventEvent;
    /**
     * 
     * @type {ShipType}
     * @memberof EventdetectorEvent
     */
    ship?: ShipType;
    /**
     * 
     * @type {EventdetectorEventEventdetector}
     * @memberof EventdetectorEvent
     */
    eventdetector?: EventdetectorEventEventdetector;
    /**
     * 
     * @type {GeoJson}
     * @memberof EventdetectorEvent
     */
    activated?: GeoJson;
    /**
     * 
     * @type {GeoJson}
     * @memberof EventdetectorEvent
     */
    deactivated?: GeoJson;
}

/**
 * Check if a given object implements the EventdetectorEvent interface.
 */
export function instanceOfEventdetectorEvent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EventdetectorEventFromJSON(json: any): EventdetectorEvent {
    return EventdetectorEventFromJSONTyped(json, false);
}

export function EventdetectorEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventdetectorEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'event': !exists(json, 'event') ? undefined : EventdetectorEventEventFromJSON(json['event']),
        'ship': !exists(json, 'ship') ? undefined : ShipTypeFromJSON(json['ship']),
        'eventdetector': !exists(json, 'eventdetector') ? undefined : EventdetectorEventEventdetectorFromJSON(json['eventdetector']),
        'activated': !exists(json, 'activated') ? undefined : GeoJsonFromJSON(json['activated']),
        'deactivated': !exists(json, 'deactivated') ? undefined : GeoJsonFromJSON(json['deactivated']),
    };
}

export function EventdetectorEventToJSON(value?: EventdetectorEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'event': EventdetectorEventEventToJSON(value.event),
        'ship': ShipTypeToJSON(value.ship),
        'eventdetector': EventdetectorEventEventdetectorToJSON(value.eventdetector),
        'activated': GeoJsonToJSON(value.activated),
        'deactivated': GeoJsonToJSON(value.deactivated),
    };
}

